import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

// --- API BAĞLANTI AYARI (Otomatik) ---
const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// --- LİNK DÜZELTİCİ FONKSİYON (YENİ EKLENDİ) ---
// Bu fonksiyon, "instagram.com/..." gibi linklerin başına "https://" ekleyerek
// site içinde açılmasını engeller ve dışarı yönlendirir.
const getExternalLink = (url) => {
  if (!url) return "#";
  // Eğer link zaten http veya https ile başlıyorsa dokunma
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  // Başlamıyorsa başına https:// ekle
  return `https://${url}`;
};

function Footer() {
  const { t } = useLanguage();
  const [settings, setSettings] = useState({}); // Ayarları tutacak state

  // Veritabanından verileri çek
  useEffect(() => {
    fetch(`${API}/settings`)
      .then(res => res.json())
      .then(data => setSettings(data || {}))
      .catch(err => console.error("Footer veri hatası:", err));
  }, []);

  return (
    <footer data-testid="footer" className="bg-slate-900 border-t border-cyan-900/30 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-emblema text-2xl text-gradient mb-4" data-testid="footer-logo">MERTT</h3>
            <p className="text-gray-400 text-sm">
              {/* Eğer footer metni veritabanında varsa onu yaz, yoksa dil dosyasından çek */}
              {settings.footer_text || t('hero.subtitle')}
            </p>
          </div>

          <div>
            <h4 className="text-cyan-400 font-semibold mb-4">{t('footer.about')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <a href="/#services" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.services')}
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                  {t('nav.blog')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-cyan-400 font-semibold mb-4">{t('nav.contact')}</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Mail size={16} />
                {/* Veritabanından gelen Email */}
                <span>{settings.email || 'info@mertt.com'}</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <Phone size={16} />
                {/* Veritabanından gelen Telefon */}
                <span>{settings.phone || '+90 5XX XXX XX XX'}</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400 text-sm">
                <MapPin size={16} />
                {/* Veritabanından gelen Adres */}
                <span>{settings.address || 'Istanbul, Turkey'}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-cyan-400 font-semibold mb-4">Social Media</h4>
            <div className="flex space-x-4">
              {/* Linkleri veritabanından çekiyoruz ve DÜZELTİCİ fonksiyonu kullanıyoruz */}
              <a href={getExternalLink(settings.facebook)} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href={getExternalLink(settings.twitter)} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors" data-testid="social-twitter">
                <Twitter size={20} />
              </a>
              <a href={getExternalLink(settings.instagram)} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href={getExternalLink(settings.linkedin)} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-cyan-900/30 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 MERTT. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;